import { jwtDecode } from "jwt-decode";

const verifyToken = (token) => {
    if (!token) {
    return { isValid: false, data: null, error: "Token no proporcionado." };
  }

  try {
    const decoded = jwtDecode(token);

    // const currentTime = Math.floor(Date.now() / 1000);
    // if (decoded.exp && decoded.exp < currentTime) {
    //   return { isValid: false, data: null, error: "El token ha expirado." };
    // }

    return { isValid: true, data: decoded, error: null };
  } catch (error) {
    return { isValid: false, data: null, error: "Token inválido o mal formado." };
  }
}

export {verifyToken}